<template>
    <div class="mx-sm-1 mt-9">
        <div class="page-header">
            <h1 class="page-title fw-bold">Les Roles</h1>
            <div>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de
                                bord</a></router-link></li>
                    <li class="breadcrumb-item active" aria-current="page"><router-link
                            :to="{ name: 'rolesPages' }"><a>Les Roles</a></router-link></li>
                </ol>
            </div>
        </div>
        <div class="row mb-3">
            <multi-select class="col-sm-3" @select="o => o.used = true" :options="columns.filter(o => !o.used)"
                :custom-label="v => v.description" placeholder="Filtrer par " label="name"
                track-by="name"></multi-select>
            <multi-select class="col-sm-3" :options="pagination" deselect-label="Sélectionné"
                :custom-label="v => v.description" placeholder="Eléments par page " label="value" track-by="value"
                :multiple="false" v-model="page"></multi-select>
            <div class="col-sm text-sm-right">
                <div class="dt-buttons btn-group">
                    <button aria-controls="kt_table_1" class="btn btn-outline-dark style_btn rounded-0" tabindex="1"
                        type="button" @click.prevent="onSearch"><span><i class="fe fe-search"></i>
                            Rechercher</span></button>
                    <!-- <button aria-controls="kt_table_1" class="btn btn-light style_btn rounded-0" tabindex="2"
                        type="button" @click.prevent="onCsv"><span><i class="fa fa-print"></i>
                            Exporter</span></button> -->
                </div>
            </div>
        </div>
        <div class="row">
            <div v-for="(item, index) in filters" :key="`filter${index}`" class="form-group col-sm">
                <div class="input-group">
                    <select v-if="item.options" v-model="item.value" class="form-control">
                        <option v-for="(obj, i) in item.options" :key="i" :value="obj.key">{{ obj.value }}</option>
                    </select>
                    <input v-else :type="item.type" class="form-control"
                        :placeholder="`Recherche de ${item.description}`" v-model="item.value">
                    <div class="input-group-append">
                        <button class="btn btn-danger" type="button" @click="item.used = false"><i
                                class="fe fe-trash"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Liste</h3>
                        <div class="card-options">
                            <SearchInputAll></SearchInputAll>
                            <button class="btn text-primary btn-sm" @click="onSearch" data-bs-toggle="tooltip"
                                data-bs-original-title="Modifier"><span class="fe fe-search fs-18"></span></button>
                        </div>
                    </div>
                    <div class="card-body">
                        <table id="data-table"
                            class="table table-responsive table-hover table-bordered text-nowrap mb-0">
                            <thead class="border-top danger02">
                                <tr class="fw-bold">
                                    <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">N</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Creer le</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Nom</th>
                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                        Permissions</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">Actions</th>
                                </tr>
                            </thead>
                            <tbody v-if="filtersItems[0]" id="myTable1">
                                <tr v-for="(item, index) in filtersItems" :key="index" class="border-bottom">
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td>{{ item?.createdAt | moment('LLLL') }}</td>
                                    <td>{{ item?.name }}</td>
                                    <td>
                                        <div v-if="item.permissions.length === 0">Aucune permission</div>
                                        <div v-else>
                                            <ul class="list-inline mb-0">
                                                <li class="" v-for="(perm, ind) in item.permissions"
                                                    :key="ind">
                                                    <span class="badge bg-info-transparent text-info">{{ perm.libelle }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="g-2">
                                            <button class="btn text-primary btn-sm" @click="edit(item)"
                                                data-bs-toggle="tooltip" data-bs-original-title="Modifier"><span
                                                    class="fe fe-edit fs-18"></span></button>
                                            <button class="btn text-danger btn-sm" @click="drop(item)"
                                                data-bs-toggle="tooltip" data-bs-original-title="Supprimer"><span
                                                    class="fe fe-trash-2 fs-18"></span></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr class="primary02">
                                    <td colspan="7" class="text-center">Aucun role trouvé</td>
                                </tr>
                            </tbody>
                        </table>
                        <paginate :records="items.totalElements || 0" v-model="items.number" :per-page="items.size"
                        :options="{ theme: 'bootstrap4', edgeNavigation: true, texts: { count: `{from} à {to} de {count} éléments|{count} éléments|Un élément`, first: '<<<', last: '>>>' } }"
                        @paginate="onSearch" />
                    </div>
                </div>
            </div>
            <!-- COL END -->
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4">
                <div class="card overflow-hidden" >
                    <div class="card-header">
                        <h3 class="card-title">{{ save ? 'Création d\'un role' : 'Modification d\'un role' }}</h3>
                    </div>
                    <div class="card-body">
                        <ValidationObserver v-slot="{ invalid }">
                            <form @submit.prevent="submit" class="">
                                <div class="form-row">
                                    <div class="form-group col-md-12 mb-0">
                                        <ValidationProvider name="Libelle" rules="required" v-slot="{ errors }">
                                            <label class="form-label">NOM ROLE <span
                                                    class="text-danger">*</span></label>
                                            <!-- <input type="text" class="form-control" id="libelle" v-model="payload.libelle" placeholder="saisir le libelle" autocomplete="libelle"> -->
                                            <textarea name="libelle" v-model="payload.name" class="form-control"
                                                id="libelle" rows="3"></textarea>
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-12 mb-0">
                                        <ValidationProvider name="Permissions" rules="" v-slot="{ errors }">
                                            <label class="form-label">Permissions </label>
                                            <multi-select class="col-sm" :options="permissions"
                                                v-model="payload.permissions" :searchable="true" :close-on-select="true"
                                                :show-labels="false" :multiple="true" :custom-label="v => v.libelle"
                                                placeholder="Choisir les permissions " label="libelle"
                                                track-by="id"></multi-select>

                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-footer mt-2 d-flex justify-content-around">
                                    <div>
                                        <button class="btn btn-success mt-4 mb-0" :disabled="invalid" v-if="save"><span
                                                class="fe fe-check"></span> Enregistrer</button>
                                        <button class="btn btn-success mt-4 mb-0" :disabled="invalid" v-else><span
                                                class="fe fe-check"></span> Modifier</button>
                                    </div>
                                    <div>
                                        <a href="javascript:void(0)"
                                            class="btn btn-danger mt-4 mb-0 text-end">Annuler</a>
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { reduce } from "lodash";
export default {
    name: "Roles",
    data() {
        return {
            loading: false,
            payload: { id: "", libelle: "", permissions: [] }, save: true,
            columns: [
                { name: 'id', description: 'id', type: 'text', used: false },
                { name: 'name', description: 'name', type: 'text', used: false },
            ],
            page: { name: 'size', description: '10 par page', value: 10, type: 'number', used: false },
            pagination: [
                { name: 'size', description: '10 par page', value: 10, type: 'number', used: false },
                { name: 'size', description: '20 par page', value: 20, type: 'number', used: false },
                { name: 'size', description: '30 par page', value: 30, type: 'number', used: false },
                { name: 'size', description: '40 par page', value: 40, type: 'number', used: false },
                { name: 'size', description: '50 par page', value: 50, type: 'number', used: false },
                { name: 'size', description: '60 par page', value: 60, type: 'number', used: false },
                { name: 'size', description: '70 par page', value: 70, type: 'number', used: false },
            ],
            exportations: [
                { name: 'ACCEPTED', description: 'Acceptée' },
                { name: 'REFUSED', description: 'Refusée' },
                { name: 'PENDING', description: 'En Cours' },
                { name: 'DIFFERED', description: 'Différée' },
                { name: 'PROCESSED', description: 'En Traitement' },
            ],
            reinit: false,
        }
    },
    computed: {
        ...mapGetters({ items: 'role/list' }),
        ...mapGetters({ permissions: 'permissions/list' }),
        filtersItems() {
            return this.items?.content || [];
        },
        filters() {
            return this.columns.filter(o => o.used);
        },
        option() {
            return reduce(this.filters, (acc, item) => (acc[item.name] = item.value, acc), {})
        },
    },
    methods: {
        ...mapActions('roles', ['all', 'add']),
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            //Réinitialiser la page quand le nombre de page change
            if (this.reinit){
                this.option.page = 0;
                this.reinit = false;
            }
            if(this.page) this.option.size = this.page.value;
            this.$router.push({ query: this.option }).catch(() => { });
            this.$store.dispatch('role/all', this.option).finally(() => this.$loading(false));
        },
        freeData() {
            this.save = true;
            this.payload = { id: "", libelle: "", permissions: [] };
        },
        submit() {
            this.$loading(true);
            this.loading = true;
            if (this.save) {
                console.log(this.payload);
                this.$http.post('/role', this.payload)
                    .then(({ data }) => {
                        if (data.status) {
                            // this.$swal.fire('Information', 'Permission enregistré avec succès.', 'success').then(() => {
                            //     this.payload = {libelle: ""};
                            // });
                            swal('Information!', data.message, 'success');
                        } else {
                            swal('Information!', data.message, 'error');
                        }
                        this.freeData();
                        this.onSearch();
                        this.save = true;
                        this.$loading(false);
                    }).catch((error) => {
                        this.$loading(false);
                        swal('Erreur!', 'Une erreur est survenue lors de l\'enregistrement du role.', 'error');
                    });
            } else {
                console.log("Editer", this.payload);
                this.$http.put('/role/' + this.payload.id, this.payload)
                    .then(({ data }) => {
                        if (data.status) {
                            swal('Information!', data.message, 'success');
                        } else {
                            swal('Information!', data.message, 'error');
                        }
                        this.freeData();
                        this.onSearch();
                        this.save = true;
                        this.$loading(false);
                    }).catch((error) => {
                        this.$loading(false);
                        swal('Erreur!', 'Une erreur est survenue lors de la modification du role.', 'error');
                    });
            }
        },
        edit(value) {
            this.$loading(true);
            this.save = false;
            this.payload = { ...value };
            this.$loading(false);
        },
        drop(item) {
            const self = this;
            swal({
                title: "Vous voulez continuer?",
                text: "La selection sera supprimee!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#FF0000",
                cancelButtonColor: "#d33",
                confirmButtonText: "Oui, supprimer!",
                cancelButtonText: "Annuler!"
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.delete('/role/' + item.id)
                        .then(({ data, status }) => {
                            if (status === 200 || status === 201) {
                                swal('Information!', data.message, 'success');
                            } else {
                                swal('Information!', data.message, 'error');
                            }
                            self.$loading(false);
                            self.onSearch();
                        }).catch((error) => {
                            self.$loading(false);
                            swal('Erreur!', 'Une erreur est survenue lors de la suppression du role.', 'error');
                        });
                }
            });

        },
    },
    created() {
        this.$store.dispatch('permissions/allData');
        this.onSearch();
    }
}
</script>

<style></style>